import {
    PersonalExtensionCallListQuery,
    usePersonalExtensionCallListQuery,
    usePersonalExtensionCallListVoicemailsQuery,
    usePersonalExtensionNumberIdQuery,
} from "./queries.generated";
import {useExtensionCapabilityQuery} from "@/pages/personal-extensions/queries.generated";
import {Capability, VoicemailEntry} from "@/api";
import {useStructureConfig} from "@/context/StructureConfigProvider";

type Call = PersonalExtensionCallListQuery["callList"]["calls"][0];
type Voicemail = VoicemailEntry;

export type DataSource =
    | {
          loading: true;
      }
    | {
          loading: false;
          voicemailEnabledForUser: boolean;
          callList: Call[];
          voicemails: Voicemail[];
      };

export const useDataSource = (userId: number): DataSource => {
    const config = useStructureConfig();
    const voicemailEnabled = config.isEnabledService("voicemail");

    const userNumberIdQuery = usePersonalExtensionNumberIdQuery({variables: {extensionId: userId}});
    const numberId = userNumberIdQuery.data?.users.items[0].numberId;

    const userCapabilitiesQuery = useExtensionCapabilityQuery({variables: {userId}});
    const callListQuery = usePersonalExtensionCallListQuery({
        variables: {extensionNumberId: numberId},
        skip: !numberId,
    });
    const voicemailsQuery = usePersonalExtensionCallListVoicemailsQuery({variables: {userId}, skip: !voicemailEnabled});

    if (
        userNumberIdQuery.loading ||
        userCapabilitiesQuery.loading ||
        callListQuery.loading ||
        voicemailsQuery.loading
    ) {
        return {loading: true};
    }

    const voicemailEnabledForUser =
        voicemailEnabled && (userCapabilitiesQuery.data?.userCapabilities?.includes(Capability.Voicemail) ?? false);

    return {
        loading: false,
        voicemailEnabledForUser,
        callList: callListQuery.data?.callList.calls ?? [],
        voicemails: voicemailsQuery.data?.voicemails.voicemails ?? [],
    };
};
